import React from 'react'
import { Singleton } from '../js/Singleton';
var language = new Singleton();

export function correctPhoneNumber(text, phoneNumber) {
  return <div className="bodyContainer">
    <p className="bodyText">{text + " | " + phoneNumber}</p>
    {/* <p className="bodyText">{"Es posible que el numero que desea marcar este incompleto:"}</p>
            <p className="bodyTextBold"><span>{"¿Desea corregirlo a "}</span><span className="bodyGreenText">{phoneNumber}<span className="bodyBlackText">{"?"}</span></span></p> */}
  </div>
}
export function recordingNotFound() {
  return <div className="bodyContainer">
    <p className="bodyText">{language.getText('alert-2030')}</p>
  </div>
}
export function configurationErrorBody() {
  return <div className="bodyContainer">
    <p className="bodyText">{language.getText('alert-2031')}</p>
  </div>
}
export function generalBody(text) {
  return <div className="bodyContainer">
    <p className="bodyText">{text}</p>
  </div>
}




// WEBPACK FOOTER //
// ./src/js/alertBodies.js